const AUTOMAGIC_SERVER_HOST = process.env.REACT_APP_AUTOMAGIC_SERVER_HOST

export const SELECT_PRODUCT = 'SELECT_PRODUCT'
  export const selectProduct = (type) => {
  return {
    type: SELECT_PRODUCT,
    payload: type
  }
}

export const GET_ALL_PURCHASES_SUCCESS = 'GET_ALL_PURCHASES_SUCCESS'
export const getPurchasesSuccess = (data) => {
  return {
    type: GET_ALL_PURCHASES_SUCCESS,
    payload: data
  }
}

export const GET_ALL_PURCHASES_FAILURE = 'GET_ALL_PURCHASES_FAILURE'
export const getPurchasesFailure = (error) => {
  return {
    type: GET_ALL_PURCHASES_FAILURE,
    payload: error
  }
}

export const GET_ALL_PURCHASES = 'GET_ALL_PURCHASES'
const getPurchasesStart = () => {
  return {
    type: GET_ALL_PURCHASES
  }
}

export const getPurchases = () => {
  return (dispatch) => {
    dispatch(getPurchasesStart())
    let jwtFromStorage = localStorage.getItem('automagic_token')
    if (!jwtFromStorage) {
      return dispatch(getPurchasesFailure("Token not found"))
    }
    return fetch(`${ AUTOMAGIC_SERVER_HOST }/users/purchases`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${jwtFromStorage}`,
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
    .then(json =>
      dispatch(getPurchasesSuccess(json))
    )
    .catch(error =>
      dispatch(getPurchasesFailure(error))
    )
  }
}

export const GET_PURCHASE_SUCCESS = 'GET_PURCHASE_SUCCESS'
export const getPurchaseSuccess = (data) => {
  return {
    type: GET_PURCHASE_SUCCESS,
    payload: data
  }
}

export const GET_PURCHASE_FAILURE = 'GET_PURCHASE_FAILURE'
export const getPurchaseFailure = (error) => {
  return {
    type: GET_PURCHASE_FAILURE,
    payload: error
  }
}

export const GET_PURCHASE = 'GET_PURCHASE'
const getPurchaseStart = () => {
  return {
    type: GET_PURCHASE
  }
}

export const getPurchase = (id) => {
  return (dispatch) => {
    dispatch(getPurchaseStart())
    let jwtFromStorage = localStorage.getItem('automagic_token')
    return fetch(`${ AUTOMAGIC_SERVER_HOST }/users/purchases/${id}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${jwtFromStorage}`,
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
    .then(json =>
      dispatch(getPurchaseSuccess(json))
    )
    .catch(error =>
      dispatch(getPurchaseFailure(error))
    )
  }
}

export const GET_GUIDELINE_SUCCESS = 'GET_GUIDELINE_SUCCESS'
export const getGuidelineSuccess = (data) => {
  return {
    type: GET_GUIDELINE_SUCCESS,
    payload: data
  }
}

export const GET_GUIDELINE_FAILURE = 'GET_GUIDELINE_FAILURE'
export const getGuidelineFailure = (error) => {
  return {
    type: GET_GUIDELINE_FAILURE,
    payload: error
  }
}

export const GET_GUIDELINE = 'GET_GUIDELINE'
const getGuidelineStart = () => {
  return {
    type: GET_GUIDELINE
  }
}

export const getGuideline = (id) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(getGuidelineStart())
      return fetch(`${ AUTOMAGIC_SERVER_HOST }/guidelines/${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(response => response.json())
      .then(json => {
        dispatch(getGuidelineSuccess(json))
        return resolve(json)
      })
      .catch(error => {
        dispatch(getGuidelineFailure(error))
        return reject(error)
      })
    })
  }
}

export const GET_PRODUCTS_SUCCESS = 'GET_PRODUCTS_SUCCESS'
export const getAvailableProductsSuccess = (data) => {
  return {
    type: GET_PRODUCTS_SUCCESS,
    payload: data
  }
}

export const GET_PRODUCTS_FAILURE = 'GET_PRODUCTS_FAILURE'
export const getAvailableProductsFailure = (error) => {
  return {
    type: GET_PRODUCTS_FAILURE,
    payload: error
  }
}

export const GET_PRODUCTS = 'GET_PRODUCTS'
const getProductsSign = () => {
  return {
    type: GET_PRODUCTS
  }
}

export const getAvailableProducts = (params) => {
  return (dispatch) => {
    dispatch(getProductsSign())
    let jwtFromStorage = localStorage.getItem('automagic_token')

    return fetch(`${ AUTOMAGIC_SERVER_HOST }/api/products/availables`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${jwtFromStorage}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(params)
    })
    .then(response => response.json())
    .then(json => {
      dispatch(getAvailableProductsSuccess(json))
    })
    .catch(error => {
      dispatch(getAvailableProductsFailure(error))
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/purchases.js